module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "user-report-page"
  }, [_c('div', {
    staticClass: "foo"
  }, [_c('h1', [_vm._v(_vm._s(_vm.locale.t('label_user_report')))]), _vm._v(" "), _c('div', {
    staticClass: "user-report-filters"
  }, [_c('div', [_c('label', {
    staticClass: "form-label"
  }, [_vm._v(_vm._s(_vm.locale.t("label_from")) + ":")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filters.fromDate),
      expression: "filters.fromDate"
    }],
    staticClass: "input date-input-sm",
    attrs: {
      "type": "date"
    },
    domProps: {
      "value": (_vm.filters.fromDate)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filters, "fromDate", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', [_c('label', {
    staticClass: "form-label"
  }, [_vm._v(_vm._s(_vm.locale.t("label_to")) + ":")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filters.toDate),
      expression: "filters.toDate"
    }],
    staticClass: "input date-input-sm",
    attrs: {
      "type": "date"
    },
    domProps: {
      "value": (_vm.filters.toDate)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filters, "toDate", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "user-report-filters__btn-wrap"
  }, [_c('button', {
    staticClass: "new-button",
    on: {
      "click": _vm.searchReport
    }
  }, [_vm._v("\n          " + _vm._s(_vm.locale.t('label_show')) + "\n        ")])])]), _vm._v(" "), (_vm.error) ? _c('div', {
    staticClass: "report-muted"
  }, [_c('i', [_vm._v(_vm._s(_vm.error))])]) : _vm._e(), _vm._v(" "), (_vm.loading) ? _c('div', {
    staticClass: "user-report-loading"
  }, [_c('my-loader', {
    staticClass: "centered-div"
  })], 1) : _vm._e(), _vm._v(" "), (!_vm.loading) ? _c('div', [_c('div', {
    staticClass: "user-report-kpis"
  }, [_c('div', {
    staticClass: "user-report-kpi"
  }, [_c('div', {
    staticClass: "user-report-kpi__title"
  }, [_vm._v(_vm._s(_vm.locale.t('label_total_registrations')))]), _vm._v(" "), _c('div', {
    staticClass: "user-report-kpi__value"
  }, [_vm._v(_vm._s(_vm.formatNumber(_vm.totalRegistrations)))])]), _vm._v(" "), _c('div', {
    staticClass: "user-report-kpi"
  }, [_c('div', {
    staticClass: "user-report-kpi__title"
  }, [_vm._v(_vm._s(_vm.locale.t('label_total_deleted_users')))]), _vm._v(" "), _c('div', {
    staticClass: "user-report-kpi__value"
  }, [_vm._v(_vm._s(_vm.formatNumber(_vm.totalDeletedUsers)))])]), _vm._v(" "), _c('div', {
    staticClass: "user-report-kpi"
  }, [_c('div', {
    staticClass: "user-report-kpi__title"
  }, [_vm._v(_vm._s(_vm.locale.t('label_expiring_this_month')))]), _vm._v(" "), _c('div', {
    staticClass: "user-report-kpi__value"
  }, [_vm._v(_vm._s(_vm.formatNumber(_vm.report.expiringThisMonth)))])]), _vm._v(" "), _c('div', {
    staticClass: "user-report-kpi"
  }, [_c('div', {
    staticClass: "user-report-kpi__title"
  }, [_vm._v(_vm._s(_vm.locale.t('label_avg_renewal_rate')))]), _vm._v(" "), _c('div', {
    staticClass: "user-report-kpi__value"
  }, [_vm._v(_vm._s(_vm.formatPercent(_vm.avgRenewalRate)))])])]), _vm._v(" "), (_vm.hasData) ? _c('div', {
    staticClass: "user-report-charts"
  }, [_c('article', {
    staticClass: "user-report-chart"
  }, [_c('header', {
    staticClass: "user-report-chart__head"
  }, [_c('div', {
    staticClass: "user-report-chart__title"
  }, [_vm._v(_vm._s(_vm.locale.t('label_registrations_vs_deleted')))])]), _vm._v(" "), (_vm.monthsRange.length) ? _c('div', {
    staticClass: "user-report-chart__rows"
  }, _vm._l((_vm.monthsRange), function(month, idx) {
    return _c('div', {
      key: 'rd-' + month + '-' + idx,
      staticClass: "user-report-chart__row"
    }, [_c('div', {
      staticClass: "user-report-chart__label"
    }, [_vm._v(_vm._s(_vm.monthLabel(month)))]), _vm._v(" "), _c('div', {
      staticClass: "user-report-chart__group"
    }, [_c('div', {
      staticClass: "user-report-chart__item"
    }, [_c('span', {
      staticClass: "user-report-chart__tag"
    }, [_vm._v(_vm._s(_vm.locale.t('label_registrations')))]), _vm._v(" "), _c('div', {
      staticClass: "user-report-chart__bar-wrap"
    }, [_c('div', {
      staticClass: "user-report-chart__bar user-report-chart__bar--reg",
      style: ({
        width: _vm.chartWidth(_vm.registrationsSeries[idx].count, _vm.maxRegistrationDeleted)
      })
    })]), _vm._v(" "), _c('span', {
      staticClass: "user-report-chart__value"
    }, [_vm._v(_vm._s(_vm.formatNumber(_vm.registrationsSeries[idx].count)))])]), _vm._v(" "), _c('div', {
      staticClass: "user-report-chart__item"
    }, [_c('span', {
      staticClass: "user-report-chart__tag"
    }, [_vm._v(_vm._s(_vm.locale.t('label_deleted_users')))]), _vm._v(" "), _c('div', {
      staticClass: "user-report-chart__bar-wrap"
    }, [_c('div', {
      staticClass: "user-report-chart__bar user-report-chart__bar--del",
      style: ({
        width: _vm.chartWidth(_vm.deletedSeries[idx].count, _vm.maxRegistrationDeleted)
      })
    })]), _vm._v(" "), _c('span', {
      staticClass: "user-report-chart__value"
    }, [_vm._v(_vm._s(_vm.formatNumber(_vm.deletedSeries[idx].count)))])])])])
  }), 0) : _vm._e()]), _vm._v(" "), _c('article', {
    staticClass: "user-report-chart"
  }, [_c('header', {
    staticClass: "user-report-chart__head"
  }, [_c('div', {
    staticClass: "user-report-chart__title"
  }, [_vm._v(_vm._s(_vm.locale.t('label_renewal')))])]), _vm._v(" "), (_vm.monthsRange.length) ? _c('div', {
    staticClass: "user-report-chart__rows"
  }, _vm._l((_vm.renewalSeries), function(row, idx) {
    return _c('div', {
      key: 'ren-' + row.month + '-' + idx,
      staticClass: "user-report-chart__row"
    }, [_c('div', {
      staticClass: "user-report-chart__label"
    }, [_vm._v(_vm._s(_vm.monthLabel(row.month)))]), _vm._v(" "), _c('div', {
      staticClass: "user-report-chart__group"
    }, [_c('div', {
      staticClass: "user-report-chart__item"
    }, [_c('span', {
      staticClass: "user-report-chart__tag"
    }, [_vm._v(_vm._s(_vm.locale.t('label_expired_users')))]), _vm._v(" "), _c('div', {
      staticClass: "user-report-chart__bar-wrap"
    }, [_c('div', {
      staticClass: "user-report-chart__bar user-report-chart__bar--expired",
      style: ({
        width: _vm.chartWidth(row.expiredUsers, _vm.maxRenewalUsers)
      })
    })]), _vm._v(" "), _c('span', {
      staticClass: "user-report-chart__value"
    }, [_vm._v(_vm._s(_vm.formatNumber(row.expiredUsers)))])]), _vm._v(" "), _c('div', {
      staticClass: "user-report-chart__item"
    }, [_c('span', {
      staticClass: "user-report-chart__tag"
    }, [_vm._v(_vm._s(_vm.locale.t('label_not_renewed_users')))]), _vm._v(" "), _c('div', {
      staticClass: "user-report-chart__bar-wrap"
    }, [_c('div', {
      staticClass: "user-report-chart__bar user-report-chart__bar--not-renewed",
      style: ({
        width: _vm.chartWidth(row.notRenewedUsers, _vm.maxRenewalUsers)
      })
    })]), _vm._v(" "), _c('span', {
      staticClass: "user-report-chart__value"
    }, [_vm._v(_vm._s(_vm.formatNumber(row.notRenewedUsers)))])])]), _vm._v(" "), _c('div', {
      staticClass: "user-report-chart__rate"
    }, [_vm._v(_vm._s(_vm.locale.t('label_renewal_rate')) + ": " + _vm._s(_vm.formatPercent(row.renewalRatePercent)))])])
  }), 0) : _vm._e()]), _vm._v(" "), _c('article', {
    staticClass: "user-report-cohort"
  }, [_c('header', {
    staticClass: "user-report-chart__head"
  }, [_c('div', {
    staticClass: "user-report-chart__title"
  }, [_vm._v(_vm._s(_vm.locale.t('label_cohort_retention')))])]), _vm._v(" "), (_vm.cohortSeries.length) ? _c('div', {
    staticClass: "content table-responsive table-full-width"
  }, [_c('table', {
    staticClass: "table-main table-main--fixed"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v(_vm._s(_vm.locale.t('label_cohort_month')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.locale.t('label_cohort_size')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.locale.t('label_m1_active')))]), _vm._v(" "), _c('th', [_vm._v("M1%")]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.locale.t('label_m2_active')))]), _vm._v(" "), _c('th', [_vm._v("M2%")]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.locale.t('label_m3_active')))]), _vm._v(" "), _c('th', [_vm._v("M3%")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.cohortSeries), function(row, idx) {
    return _c('tr', {
      key: 'coh-' + row.cohortMonth + '-' + idx
    }, [_c('td', [_vm._v(_vm._s(_vm.monthLabel(row.cohortMonth)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.formatNumber(row.cohortSize)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.formatNumber(row.m1Active)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.rowPercent(row.m1Active, row.cohortSize)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.formatNumber(row.m2Active)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.rowPercent(row.m2Active, row.cohortSize)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.formatNumber(row.m3Active)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.rowPercent(row.m3Active, row.cohortSize)))])])
  }), 0)])]) : _vm._e()])]) : _c('div', {
    staticClass: "user-report-empty"
  }, [_vm._v("\n        😐 " + _vm._s(_vm.locale.t('label_no_data_for_period')) + "\n      ")])]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4a837caf!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Report/UserReport.vue
// module id = 778
// module chunks = 0